var exports = {
  "W": "x8b4e8595--a77b25--labels",
};

module.exports = exports;
